<div style="height: 3px; background-color: #ffcf00; width: 100%"></div>
<div class="modal-header">
  <h4 class="modal-title" style="font-weight: 700">Authentication Error</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)=activeModal.close()></button>
</div>

<div class="modal-body">
  <div style="padding: 1rem 0">
    {{error.error?.message}}
  </div>
  <div style="padding: 1rem 0">
    Please contact <a href="mailto: support.ridecare@bosch.com">{{ 'APP.email' | translate }}</a> for further assistance.
  </div>
</div>
